import { Injectable } from '@angular/core';

import { ApiService, GlobalVar } from 'src/app/services';

@Injectable({
  providedIn: 'root'
})
export class ProtocolService {

  constructor(
    public globalvar: GlobalVar,
    public apiService: ApiService,
  ) { }

  post(body) {

  }

  put() {

  }

  get() {

  }

  getAll() {
    return this.apiService.get(`${this.globalvar._getProtocols}/${this.globalvar._user.id}`);
  }
}
